<template>
    <v-btn
        @click="ClickEvent"
        class="btn text-capitalize"
        depressed
        style="border-radius: 5px"
        large
        :width="width"
        :to="to"
        :loading="loading"
        :height="height ? height : '35px'"
        :color="color"
        :disabled="disabled"
        :block="block"
        :class="type === 'secondary' ? 'second' : 'primary'"
    >
        <span v-if="label">{{ label }}</span>

        <v-icon v-if="icon">{{ icon }}</v-icon>
    </v-btn>
</template>

<script>
export default {
    name: 'Button',
    props: [
        'label',
        'color',
        'height',
        'width',
        'to',
        'disabled',
        'loading',
        'block',
        'icon',
        'type'
    ],
    methods: {
        ClickEvent() {
            this.$emit('ClickEvent')
        },
        calculateWidth() {
            this.headers
        }
    }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,400;1,300&display=swap');

.primary {
    background: #1976d2;
    color: white;
    padding: 20px 25px 20px 25px;
}
.primary:hover {
    color: white !important;
    background-color: #050c42 !important;
}
.second {
    background: #ddecf7 !important;
    color: #0077c8 !important;
    padding: 20px 25px 20px 25px;
}
.second:hover {
    color: white !important;
    background-color: #050c42 !important;
}
</style>
